import { Injectable } from '@angular/core';
import { AuditoresFilters } from '../models/auditores-filters.model';
import { EtiquetadoresFilters } from '../models/etiquetadores-filters.model';
import { ProductoresFilters } from '../../cultivos/models/productores-filters.model';
import { UsuariosFilters } from '../models/usuarios-filters.model';


@Injectable()
export class UsuariosContextService {
  public usuariosFilters: UsuariosFilters;
  public etiquetadoresFilters: EtiquetadoresFilters;
  public auditoresFilters: AuditoresFilters;

  constructor() { }
}
